import React from "react";

export const LinkedinSvg = () => {
    return (
        <a href="https://www.linkedin.com/in/antoine-fawer-b6224b300/" target="_blank" rel="noopener noreferrer">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor"
            >
                <path
                    d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 20h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.604c0-1.338-.026-3.064-1.865-3.064-1.865 0-2.152 1.456-2.152 2.962v5.706h-3v-11h2.881v1.501h.041c.401-.757 1.379-1.555 2.839-1.555 3.036 0 3.594 2.002 3.594 4.604v6.45z"/>
            </svg>
        </a>
    )
}

